<div class="alg-tooltip-container {{ styleClass() }}">
  @if (contentTemplate(); as template) {
    <ng-container [ngTemplateOutlet]="template"></ng-container>
  } @else {
    {{ text() }}
  }
</div>
